/**
 * Alert Row Component
 * Individual row with expandable feedback
 */

import React from 'react';
import { Alert } from '../types';

interface AlertRowProps {
  alert: Alert;
  onClick: () => void;
}

export const AlertRow: React.FC<AlertRowProps> = ({ alert, onClick }) => {
  return (
    <tr 
      className={`alert-row priority-${alert.priority?.toLowerCase() || 'low'}`}
      onClick={onClick}
    >
      <td>{alert.id}</td>
      <td>{new Date(alert.created_at).toLocaleDateString()}</td>
      <td>{alert.itemname}</td>
      <td>
        <span className={`badge priority-${alert.priority?.toLowerCase()}`}>
          {alert.priority}
        </span>
      </td>
      <td>{alert.fault_description}</td>
      <td>{alert.fault_rectification_status}</td>
      <td>{alert.fault_accuracy}</td>
    </tr>
  );
};
